import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';

import { IceEntity, IIceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { IBaseView } from '../../../../icemedx-lib/src/components/baseview.component';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition,
  IcecontrolPermission,
  IceResponsiveMattableSettings
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';

const PaymentPostDomainType = "PaymentPostDomainType";
const PaymentPostNameofDomain = "PaymentPostNameofDomain";

@Component({
  selector: 'app-paymentposting',
  templateUrl: './paymentposting.component.html',
  styleUrls: ['./paymentposting.component.scss'],
  providers: [AppService, IceNavService]
})
export class PaymentpostingComponent implements OnInit, IBaseView {

  // data members
  private superbillChargesKey: string = null;

  // member settings
  postingViewSettings: IcepanelcontainerSettings = null;
  postingPermission: IcecontrolPermission = null;

  //////////////////////
  // Order Info. Controls
  private ctrlBillingDomainType: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: DomainService.getDomainTypes(), width: "100%" }, null, null, PaymentPostDomainType, "Type of Bill") // Type of Receiving or Checkout Bill
    .setControlName(PaymentPostDomainType)
    .createFormControl(0, [Validators.required]);
  private ctrlBillingDomainNameCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "100%" }, null, null, PaymentPostNameofDomain, "Enter Name of Network Domain") // ...Network Domain Bill To or From
    .setControlName(PaymentPostNameofDomain)
    .createFormControl("", [Validators.required]);

  private postingDomainSection: IcepanelsectionSettings = null;
  private postingDomainNameAndOrderSection: IcepanelsectionSettings = null;
  private loaderSection: IcepanelsectionSettings = null;

  constructor() { }

  ngOnInit() {
  }

  viewSetup(dat: IIceEntity): IcepanelcontainerSettings {
    return null
  }
}

